var Event = /** @class */ (function () {
    function Event() {
    }
    return Event;
}());
export { Event };
//# sourceMappingURL=event.js.map